import { MicrositeCTAUI } from "./components/MicrositeCTA/MicrositeCTAUI";
import { IntegratedCTAUI } from "./components/IntegratedCTA/IntegratedCTAUI";
import { useState } from "react";
import TradeInModal from "./components/TradeInModal/TradeInModal";

type Props = {
  dispatchTradeInStartedAnalytics: () => void;
  hasMultipleTradeInRoutes: boolean;
};

export const TradeInUI = ({
  dispatchTradeInStartedAnalytics,
  hasMultipleTradeInRoutes,
}: Props) => {
  const [isTradeInModelLoading, setTradeInModelLoading] =
    useState<boolean>(false);
  const [isTradeInModelOpen, setTradeInModelOpen] = useState<boolean>(false);
  const integratedOnClick = () => {
    dispatchTradeInStartedAnalytics && dispatchTradeInStartedAnalytics();
    setTradeInModelLoading(true);
    setTradeInModelOpen(true);
  };

  const modalOnClose = () => {
    setTradeInModelOpen(false);
    setTradeInModelLoading(false);
  };

  return (
    <div data-component="TradeIn">
      {hasMultipleTradeInRoutes && (
        <>
          <IntegratedCTAUI
            isTradeInModelLoading={isTradeInModelLoading}
            onClick={integratedOnClick}
          />
          <TradeInModal
            isOpen={isTradeInModelOpen}
            onClose={modalOnClose}
            onFetchQuotesComplete={() => setTradeInModelLoading(false)}
            setTradeInModelOpen={setTradeInModelOpen}
          />
        </>
      )}
      <MicrositeCTAUI hasMultipleTradeInRoutes={hasMultipleTradeInRoutes} />
    </div>
  );
};
